export default function Marquee({ items, dark = false, className = "" }) {
  const seq = (ariaHidden) => (
    <div aria-hidden={ariaHidden || undefined} className="flex flex-shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-mono text-xs uppercase tracking-[0.35em] sm:px-10 sm:text-sm">
            {item}
          </span>
          <span className={dark ? "text-crimson" : "text-crimson"}>✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`marquee-pause overflow-hidden border-y ${dark ? "border-white/10 bg-ink text-alabaster" : "border-linec bg-alabaster text-ink"} ${className}`}
      data-testid="marquee"
    >
      <div className="animate-marquee flex w-max py-4">
        {seq(false)}
        {seq(true)}
      </div>
    </div>
  );
}
